import { RRule } from 'rrule';
import { Menu } from '@shared/components/Menu';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBTextInput } from '@shared/components/textInput';
import { Batch } from '@shared/scenes/cards/entityBulkActions/BatchCreateContext/BatchContext';
import { i18n } from '@shared/util/i18n';
import { MonthOptions } from './MonthOptions';
import { WeekOptions } from './WeekOptions';
import { YearOptions } from './YearOptions';
import { useCustomBatch } from './hooks/useCustomBatch';

export function CustomBatchDesktop({
  rruleOptions,
  setRruleOptions,
  setUserIsEditing,
}: Pick<Batch, 'rruleOptions' | 'setRruleOptions' | 'setUserIsEditing'>) {
  const { frequencyLabel, interval, freqOptions, handleIntervalChange } = useCustomBatch({
    rruleOptions,
    setRruleOptions,
    setUserIsEditing,
  });

  return (
    <View paddingHorizontal={2} gap={1}>
      <View row gap={1}>
        <View centerVertically>
          <Text size="body1" weight="semibold">
            {i18n('workflowTemplate.component.dateAndRepeat.everyDotDotDot')}
          </Text>
        </View>
        <View flex>
          <MBTextInput value={String(interval ?? '')} onChangeText={handleIntervalChange} />
        </View>
        <Menu>
          <Menu.Button flex label={frequencyLabel} />
          <Menu.Content>
            <Menu.Options
              options={freqOptions}
              onSelect={option => option.onPress()}
              getItemKey={option => option.title}
              getItemLabel={option => option.title}
              isItemSelected={option => option.frequency === rruleOptions?.freq}
            />
          </Menu.Content>
        </Menu>
      </View>
      {rruleOptions?.freq === RRule.WEEKLY && (
        <WeekOptions rruleOptions={rruleOptions} setRruleOptions={setRruleOptions} />
      )}
      {rruleOptions?.freq === RRule.MONTHLY && (
        <MonthOptions rruleOptions={rruleOptions} setRruleOptions={setRruleOptions} />
      )}
      {rruleOptions?.freq === RRule.YEARLY && (
        <YearOptions rruleOptions={rruleOptions} setRruleOptions={setRruleOptions} />
      )}
    </View>
  );
}
